import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

const GeneralLayout = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default GeneralLayout;